module.exports = __webpack_public_path__ + "static/media/Nobody's Love.670938e6.mp3";